import {Component, OnChanges, input} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PercentPipe } from '@angular/common';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';

@Component({
    selector: 'esp-download-map-datatable, [espDownloadMapDatatable]',
    templateUrl: './download-map-datatable.component.html',
    styleUrls: ['./download-map-datatable.component.scss'],
    imports: [MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, PercentPipe, TranslateModule]
})
export class DownloadMapDatatableComponent implements OnChanges {

    totalDownloads = 0;
    displayedColumns: string[] = ['country', 'downloads', 'percent'];

    readonly downloadsByCountry = input(undefined);

    constructor() {}

    ngOnChanges(): void {
        const downloadsByCountry = this.downloadsByCountry();
        if (downloadsByCountry && downloadsByCountry.length > 0) {
            this.totalDownloads = downloadsByCountry.map(country => country.value).reduce((a,b) => {return a + b; });
        }
    }



}
